<template>
  <div>
    <!-- base buttons sessions -->
    <b-row class=" m-0 pt-0 pb-0 base_buttons_session">
      <base-alert v-if="blockEdit && !this.handle_city_agents" type="danger" class="w-100">
        <i class="fa fa-exclamation-triangle"></i>
        <p>Sem permissão de edição</p>
      </base-alert>

      <base-alert v-if="blockEdit && this.handle_city_agents" type="warning" class="w-100">
        <i class="fa fa-exclamation-triangle"></i>
        <p>Antes de editar é necessário vincular esse cadastro!</p>
      </base-alert>
    </b-row>

    <b-form>
      <!-- START user data sesssion -->
      <div v-show="currentPage.includes('user_data_session')" class="user_data_session">
        <div class="d-flex align-items-center">
          <span class="pr-4 pl-2 bg-white align-items-center" style="color:#12576e; font-weight: 600;">
            <i class="no no-user pr-1"></i>Sobre o condutor
          </span>
        </div>

        <div class="img-agent-info w-100 mt-3 align-items-center">
          <div class="d-block" style="width: 20%;">
            <div class="text-center pb-2">
              <div class="image-upload-wrapper" @click="triggerFileInput">
                <b-img v-if="agentTmpImage" :src="agentTmpImage" onerror="this.src = 'img/theme/backpacker.png' "
                  class="image-preview" width="160px">
                </b-img>

                <input ref="fileInput"  type="file" @change="onImageChange" accept=".jpg, .png, .jpeg"
                  class="hidden-input">
              </div>
            </div>
          </div>

          <div class="top-2-input d-block w-100">
            <base-input v-model="agentData.name" :disabled="blockEdit" minlength="5" name="Nome" bc_label="name"
              v-on:blur="validateField" type="text" label="Nome completo" required
              v-bind:class="{ 'is-invalid': fieldErrors['name'] }" aria-invalid="Campo Nome não pode estar vazio">
            </base-input>

            <base-input v-model="agentData.nickname" :disabled="blockEdit" type="text" label="Apelido">
            </base-input>
          </div>
        </div>

        <base-input v-show="false" v-model="agentData.user_id" type="text" label="UUID" name="uuid"></base-input>

        <base-input v-show="true" v-model="agentData.cpf" :disabled="blockEdit"
          v-bind:class="{ 'is-invalid': fieldErrors['cpf_cnpj'] }"
          v-mask="getDocMask(agentData.cpf)"
          maxlength="18"
          bc_label="cpf_cnpj" aria-invalid="Campo CPF/CNPJ não pode estar vazio" v-on:blur="validateField"
          @keyup="agentData.cpf = String(agentData.cpf || '').toUpperCase()"
          type="text" label="Documento" name="CPF/CNPJ" required>
        </base-input>

        <base-input v-show="false" type="select">
          <select :disabled="true" class="form-control" v-model="agentData.category">
            <option v-for="(category, categoryID) in agentCategories" :key="categoryID" :label="category"
              :value="categoryID">
            </option>
          </select>
        </base-input>
      </div>
      <!-- END user data sesssion -->

      <!-- START xfield sessions -->
      <div v-show="formFields.length" class="xfieldsDataWrapper">
        <div v-for="(fields, session_title) in enabledFormFields" :key="`${session_title}`">
          <div v-if="fields[1].filter(field => field.type != 'hidden_config').length"
            v-show="currentPage.includes(fields[0])" :class="[`${fields[0]}`]">

            <div class="row">
              <div v-for="(field) in fields[1]" :key="field.id" v-show="(field.type != 'hidden_config' || !(field.label.indexOf('page_') === 0)) && field.label != 'active'"
                :class="field.type == 'hidden_config' && field.label.indexOf('session_title') === 0 ? 'col-12 mb-3' : 'col-md-6 mb-2'">
                <h3 v-if="field.type == 'hidden_config' && field.label.indexOf('session_title') === 0" class="pt-2 w-100">
                  <span class="pr-4 bg-white align-items-center" style="color:#12576e; font-weight: 600;">
                    <i class="no no-user pr-1"></i>{{ field.public_label }}
                  </span>
                  <hr class="mt--2">
                </h3>

                <!-- BASE INPUT NÃO SUPORTA IMAGENS -->
                <b-col v-if="field.type == 'img'" class="text-center">
                  <b-img v-if="mainPlaceAgentData[field.label]['value'] != ''" :src="mainPlaceAgentData[field.label]['value']" onerror="this.src = 'img/theme/backpacker.png'"
                    class="text-center" style="border:1px dashed gray" width="150px">
                  </b-img>
                </b-col>

                <base-input v-if="field.type != 'hidden_config' && field.type != 'img' && field.show !== false" :name="field.label"
                  :label="field.type != 'checkbox' ? (field.public_label ? field.public_label : field.label) : ''">

                  <b-form-file v-if="field.type == 'file'" @change="onFileChange" :name="field.label" :public_label="field.public_label" :readonly="!blockEdit"
                    accept=".jpg, .png, .jpeg, .pdf, .doc, .docx, .xls, .csv, .xlsx" size="md" placeholder="Escolha um arquivo...">
                  </b-form-file>

                  <b-form-checkbox v-if="field.type == 'checkbox' && !field.multiple && field.label != 'active'" v-model="mainPlaceAgentData[field.label]['value']"
                    :disabled="blockEdit" class="mb-3">
                    {{ field.public_label }}
                  </b-form-checkbox>

                  <!-- START type select -->
                  <div v-if="field.type == 'select'">
                    <multiselect v-model="mainPlaceAgentData[field.label]['value']" :multiple="field.multiple" :id="field.label" :disabled="blockEdit"
                      :close-on-select="!field.multiple" :clear-on-select="false" :hide-selected="false" :placeholder="field.multiple ? 'Selecionar...' : 'Escolher...'"
                      deselect-label="Remover" select-label="Selecionar" selected-label="Selecionado" track-by="id" label="label"
                      :options="field.options" :searchable="field.options && field.options.length > 6">
                    </multiselect>
                  </div>
                  <!-- END type select -->

                  <date-picker v-if="field.type == 'date'" v-model="mainPlaceAgentData[field.label]['value']" :disabled="blockEdit" type="date" format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd" class="w-100 mb-1">
                  </date-picker>

                  <b-textarea v-if="field.type == 'textarea'" v-model="mainPlaceAgentData[field.label]['value']" :disabled="blockEdit"></b-textarea>

                  <b-row align-h="between">
                    <b-col v-if="['mobile', 'phone'].includes(field.label)" cols="3">
                      <b-form-select v-model="phoneFlag" class="mb-3">
                        <template #first>
                          <b-form-select-option value="" disabled>Selecione o país</b-form-select-option>
                        </template>

                        <b-form-select-option :class="flag" v-for="(flag, idx) in dialCodesArray" :value="flag.iso" :key="idx">
                          {{ getFlagEmoji(flag.iso) + ' ' + flag.name + ' +' + flag.dialcode }}
                        </b-form-select-option>
                      </b-form-select>
                    </b-col>

                    <b-col :cols="['mobile', 'phone'].includes(field.label) ? '9' : '12'">
                      <b-input v-if="!['checkbox', 'checkboxmultiple', 'file', 'select', 'file-image', 'selectmultiple', 'date', 'textarea'].includes(field.type)"
                        v-model="mainPlaceAgentData[field.label]['value']" :value="mainPlaceAgentData[field.label]['value']" :type="field.type" :disabled="blockEdit">
                      </b-input>
                    </b-col>
                  </b-row>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END xfield sessions -->

      <!-- afilitaion -->
      <div v-if="handle_city_agents && currentPage.includes('afilitaion_data_session')" class="afilitaion_data_session">
        <span class="pr-4 pl-2 bg-white align-items-center" style="color:#12576e; font-weight: 600;">
          <i class="no no-user pr-1"></i>Vínculo Institucional
        </span>

        <hr class="mt--2">
        <base-input v-if="handle_city_agents" label="Afiliação">
          <select v-model="agentData.place_id" @change="changeBlockEdit()" class="form-control">
            <option v-for="(placeName, id) in agentPlaces" :key="id" :selected="agentData.place_id == id"
              :label="placeName" :value="id">
              {{ id + ' -- ' + agentData.place_id }}
            </option>
          </select>
        </base-input>
      </div>

      <!-- formation -->
      <base-input v-if="handle_my_place_agents && currentPage.includes('formation_data_session')">
        <b-row v-if="Object.keys(agentFormationCourses).length > 0" align-h="between">
          <b-col cols="12" class="formation_data_session">
            <span class="pr-4 pl-2 bg-white align-items-center" style="color:#12576e; font-weight: 600;">
              <i class="no no-user pr-1"></i>Formação e Cursos
            </span>
            <hr class="mt--2">

            <div v-for="(courseItem, key) in Object.entries(agentFormationCourses)" :key="key">
              <div class="d-inline-block">
                <strong>{{ courseItem[1]['label'] }}</strong>

                <div class="ml-3 d-inline-flex align-items-center ">
                  <span @click="setAgentLastFormation(courseItem[0])" style="color: #12576e; cursor: pointer;">
                    Adicionar curso
                  </span>

                  <div class="verticalLine ml-3 mr-2"></div>

                  <b-row align-self="start" class="row-1 text-right mr-4">
                    <b-dropdown menu on right no-caret id="dropdown-1" class="custom-dropdown" :disabled="disableCourseHistory(courseItem)">
                      <template v-slot:button-content>
                        <h4 class="mb-0" style="color: #A7AA37;" >
                          <i class="ni ni-bullet-list-67 mt-1"></i>
                        </h4>
                      </template>

                      <div v-for="course in courseItem[1]['courses']" :key="`downloadlist_${course.id}`" style="min-width: 450px;">
                        <span v-if="agentData.formations[course.id] >= 0" :id="`achbx_${courseItem[0]}_${course.date.substring(0, 4)}`" class="ml-3">
                          <span>{{ course.date.substring(0, 4) }}: </span>

                          <span v-if="mainPlaceAgentData[`formationvalid_${course.id}_${course.date.substring(0, 4)}`] != undefined">
                            válido até {{ mainPlaceAgentData[`formationvalid_${course.id}_${course.date.substring(0,4)}`]['value'] }}
                          </span>
                          <span v-else>Sem Validade</span>

                          <span v-if="mainPlaceAgentData[`formationfile_${course.id}_${course.date.substring(0, 4)}`] != undefined" style="color: #A7AA37; cursor: pointer;"
                            @click="downloadFile(mainPlaceAgentData[`formationfile_${course.id}_${course.date.substring(0, 4)}`]['value'], mainPlaceAgentData[`formationfile_${course.id}_${course.date.substring(0, 4)}`]['public_label'])">
                            | Baixar comprovante
                          </span>
                          <span v-else> | Sem Anexo</span>

                          <span @click="removeAgentFormation(courseItem[0], course.date.substring(0, 4), course.id)" style="color: #D93051; cursor: pointer;">
                            | Remover
                          </span>
                        </span>
                      </div>
                    </b-dropdown>
                  </b-row>

                </div>
                
                <div v-if="!disableCourseHistory(courseItem)" class="ml-2 mt-0 mb-0">
                  <span v-if="getLastCourseItem(courseItem)" :id="`achbx_${courseItem[0]}_${getLastCourseItem(courseItem).date.substring(0, 4)}`" class="ml-3">
                    <span>{{ getLastCourseItem(courseItem).date.substring(0, 4) }}: </span>

                    <span v-if="mainPlaceAgentData[`formationvalid_${getLastCourseItem(courseItem).id}_${getLastCourseItem(courseItem).date.substring(0, 4)}`] != undefined">
                      válido até {{ mainPlaceAgentData[`formationvalid_${getLastCourseItem(courseItem).id}_${getLastCourseItem(courseItem).date.substring(0,4)}`]['value'] }}
                    </span>
                    <span v-else>Sem Validade</span>

                    <span v-if="mainPlaceAgentData[`formationfile_${getLastCourseItem(courseItem).id}_${getLastCourseItem(courseItem).date.substring(0, 4)}`] != undefined" style="color: #A7AA37; cursor: pointer;"
                      @click="downloadFile(mainPlaceAgentData[`formationfile_${getLastCourseItem(courseItem).id}_${getLastCourseItem(courseItem).date.substring(0, 4)}`]['value'], mainPlaceAgentData[`formationfile_${getLastCourseItem(courseItem).id}_${getLastCourseItem(courseItem).date.substring(0, 4)}`]['public_label'])">
                      | Baixar comprovante
                    </span>
                    <span v-else> | Sem Anexo</span>

                    <span @click="removeAgentFormation(courseItem[0], getLastCourseItem(courseItem).date.substring(0, 4), getLastCourseItem(courseItem).id)" style="color: #D93051; cursor: pointer;">
                      | Remover
                    </span>
                  </span>
                </div>
              </div>

              <!-- aquivos disponíveis -->
              <div class="d-inline-block column_count_3 w-100 mb-1" style="max-height:100px;column-width: auto;background-color: #ababab;">
                <b-form-checkbox v-show="false" v-for="course in courseItem[1]['courses']" :key="course.id" :id="`chbx_${courseItem[0]}_${course.date.substring(0, 4)}`" 
                  :disabled="blockEdit" class="ml-3" :checked="agentData.formations[course.id] >= 0" @change="setAgentFormation(course, courseItem[0])">
                  {{ course.date.substring(0, 4) }}
                </b-form-checkbox>
              </div>

              <b-row v-for="courseData in currentCoursersItems" :key="courseData.id" :disabled="blockEdit" class="ml-3 align-items-center mr-0">
                <div v-if="agentData.formations[courseData.id] >= 0 && courseItem[0] == courseData.slug" class="course_data_wrapper w-100 mt--3">
                  <div class="removebuttonmask mb-2">
                    <div v-for="course in courseItem[1]['courses']" :key="`downloadlist_${course.id}`" class="contentbuttonmask">
                      <span v-if="agentData.formations[course.id] >= 0" :id="`achbx_${courseItem[0]}_${course.date.substring(0, 4)}`">
                        <span @click="removeAgentFormation(courseItem[0], course.date.substring(0, 4), course.id)" style="cursor: pointer; color: #D93051">
                          Cancelar
                        </span>
                      </span>
                    </div>
                  </div>

                  <b-row class="align-items-center">
                    <b-col cols="3" class="d-inline-block">
                      <base-input type="select">
                        <select @change="toggleAgentFormation($event, courseData, courseItem[0])" class="form-control">
                          <option v-for="(courseYear, courseYearID) in courseYears" :key="courseYearID" :label="courseYear" :value="courseYearID"
                            :selected="courseYear == courseData.date.substring(0, 4)" :disabled="isCourseAvailable(courseItem[0], courseYear)">
                          </option>
                        </select>
                      </base-input>
                    </b-col>

                    <b-col cols="3" class="d-inline-block">
                      <base-input type="select">
                        <select class="form-control" @change="setCourseLimit($event, courseData, courseItem[0])">
                          <option v-for="(courseYear, courseYearID) in courseLimitYears" :key="courseYearID" :label="courseYear" :value="courseYearID"
                            :selected="courseYear == (new Date()).getFullYear()" :disabled="courseYear < courseData.date.substring(0, 4)">
                          </option>
                        </select>
                      </base-input>
                    </b-col>

                    <b-col cols="6" class="d-inline-block">
                      <base-input type="select">
                        <b-form-file :name="`formationfile_${courseData.id}_${courseData.date.substring(0, 4)}`"
                          :public_label="`Certificado: ${courseData.name} (${courseData.date.substring(0, 4)})`" @change="onFileChange" :readonly="!blockEdit" 
                          accept=".jpg, .png, .jpeg, .pdf, .doc, .docx" size="md" :placeholder="`carregar arquivo`">
                        </b-form-file>
                      </base-input>
                    </b-col>
                  </b-row>
                </div>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </base-input>
      <!-- fim form global -->
    </b-form>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from "moment"
import * as chartConfigs from "@/components/Charts/config"
import { DatePicker } from "element-ui"
import { Charts } from "@/components/Charts/config"
import { hasModule } from '../../store/utils/users'
import cakeService from '@/services/cakephp'
import bocapioService from "@/services/nodejs/index"
import QrcodeVue from 'qrcode.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import "sweetalert2/dist/sweetalert2.css"
import { VueMaskDirective } from 'v-mask'
import Multiselect from 'vue-multiselect'

export const cakeBaseURL = process.env.VUE_APP_API_CAKE_URL; // cake api
export const nodeBaseURL = process.env.VUE_APP_API_NODE_URL; // node api

export default {
  component: 'AgentForm',

  directives: { mask: VueMaskDirective },

  components: {
    // LineChart
    DatePicker,
    Multiselect,
    QrcodeVue
  },

  props: {
    agent: {
      type: Object,
    },

    mainPlaceAgentData: {
      type: Object,
    },

    formWaiting: {
      type: Boolean,
      default: false,
    },

    blockEdit: {
      type: Boolean,
      default: false,
    },

    isBackable: {
      type: Boolean,
      default: true,
    },

    isNextable: {
      type: Boolean,
      default: true,
    },

    removeAfiliatedCheckbox: {
      type: Boolean,
      default: true,
    },

    currentPage: {
      type: Array,
      default: [],
    },

    dialCodesArray: {
      type: Array | Object,
      default: [] | {},
    },

    enabledFormFields: {
      type: Array | Object,
      default: [] | {},
    },

    pageControl: {
      type: String,
      default: "pagecontrol_1",
    },

    pages: {
      type: Array | Object,
      default: [] | {},
    },

    agentTmpFiles: {
      type: Object,
      default: {},
    },

    agentTmpImage: {
      type: String,
      default: '',
    },

    formErrors: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formFields: [], fieldErrors: {},
      countries: [], states: [], cities: [],
      currentCoursersItems: [],
      agentData: { uuid: '', name: '', nickname: '', cpf: '', user_id: '', images: '', formations: '', },
      loading: false, handle_my_place_agents: false, handle_city_agents: false,
      bills: {}, paidBills: {}, unpaidBills: "",
      agentPlaces: [], agentFormationCourses: [],
      associatePlaceType: 14, //Tourism places 14 => 'Associações de condutores de visitantes'
      valueTotalUnpaidBills: "", firstUnpaidBill: "",
      totalValue: 0, billscount: 0,
      salesChart: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "Valor comprado",
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
      extraOptions: {
        scales: {
          yAxes: [{
            gridLines: {
              color: Charts.colors.gray[200],
              zeroLineColor: Charts.colors.gray[200]
            }
          }]
        }
      },
      agentCategories: { '1': 'Condutor', '2': 'Fornecedor', '3': 'Associado' },
      courseYears: {}, courseLimitYears: {}, phoneFlag: 'BR',
    };
  },

  computed: {
    ...mapGetters('auth', {
      place: 'getPlace',
    }),

    getNodeBaseURL() { return nodeBaseURL },

    getWindowOrigin() { return window.location.origin },

  },

  watch: {
    bills() {
      if (this.bills.view.unpaidBillsProducts.length > 0) {
        //valor total das contas
        this.billscount = {}
        this.bills.view.unpaidBillsProducts.map((bill) => {
          this.billscount[bill.Bills.id] = 1
          this.totalValue += parseFloat(bill.BillsProduct.price * bill.BillsProduct.amount);
        })

        this.billscount = Object.keys(this.billscount).length
        //total em itens e de contas pendentes
        this.unpaidBills = `${this.bills.view.unpaidBillsProducts.length.toString()} itens em ${this.billscount} contas`
        this.valueTotalUnpaidBills = `R$ ${this.totalValue.toFixed(2).toString().replace(".", ",")}`;

        const [data, hora] = this.bills.view.unpaidBillsProducts[this.bills.view.unpaidBillsProducts.length - 1].BillsProduct.date.split(" ");
        const [ano, mes, dia] = data.split("-");

        var a = moment();
        var b = moment([ano, mes - 1, dia])
        //tempo em meses de débito
        this.firstUnpaidBill = `${a.diff(b, "days").toString()} Dias`;
      }
      else {
        this.unpaidBills = "0"
        this.valueTotalUnpaidBills = "R$ 0,00"
        this.firstUnpaidBill = "-"
      }
      this.loadChartData()
    },

  },

  methods: {
    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);

        if (!collection) { map.set(key, [item]); }
        else { collection.push(item); }
      });
      return Array.from(map);
    },

    getFlagEmoji(countryCode) {
      const codePoints = countryCode.toUpperCase().split('').map(char => 127397 + char.charCodeAt());
      return String.fromCodePoint(...codePoints);
    },

    async loadAgentFormationCourses() {
      const { formations } = await cakeService.getFormations()
      this.agentFormationCourses = []
      const vm = this
      var _formations = new Array()

      formations.map((item) => {
        var label = item.Formation.name.toUpperCase().replace(/[^A-Z]+/g, '')
        if (undefined == vm.agentFormationCourses[label]) {
          vm.agentFormationCourses[label] = { label: item.Formation.name, courses: new Array() }
        }
        vm.agentFormationCourses[label].courses.push(item.Formation)
      })

      if (undefined != this.agentData.AgentsFormations) {
        this.agentData.formations = new Array()
        Object.values(this.agentData.AgentsFormations).map(formation => {
          this.agentData.formations[formation.formation_id] = formation.formation_id
        })
      }
      else {
        if (undefined != this.agentData.formations) {
          this.agentData.formations.map(formation => {
            if ("" != formation) {
              _formations[formation] = formation
            }
          })
        }
        this.agentData.formations = _formations
      }
    },

    setBlockEdit() {
      if (this.handle_city_agents) {
        var blockEdit = this.agentData.place_id == 0
        this.$emit('emitBlockEdit', blockEdit)
      }
      else if (!this.agentData.currentPlaceHasMainAffiliation && !this.agentData.isNew) {
        // this.blockEdit = true
        this.$emit('emitBlockEdit', true)
      }
    },

    getLastCourseItem(courseItem){
      var courseIndex = this.agent.AgentsFormations.findIndex(f => f.Formation.name == courseItem[1].label)

      if(courseIndex >= 0){
        var agentCourse = this.agent.AgentsFormations[courseIndex]
        var lastAgentCourseIndex = courseItem[1].courses.findIndex(c => c.id == agentCourse.formation_id)

        if(lastAgentCourseIndex >= 0){ return courseItem[1].courses[lastAgentCourseIndex] }
        else{ return [] }
      }
      else{ return [] }
    },

    disableCourseHistory(courseItem){
      var courseIndex = this.agent.AgentsFormations.findIndex(f => f.Formation.name == courseItem[1].label)
      return courseIndex < 0
    },

    async loadAgentAssociatePlaces() {
      // TODO: use store.state from @/store instead...
      let agentCityId = this.place.city.id
      let params = [agentCityId, this.associatePlaceType]
      const { list } = await cakeService.getPlacesList(params)
      this.agentPlaces = list
      this.agentPlaces[0] = 'Não afiliado'
    },

    last12Mounths(now = moment()) {
      let months = []
      for (let i = 1; i <= 12; i++) {
        const month = moment(now).format('MMM')
        months.push(month)
        now = moment().subtract(i, 'M')
      }
      return months
    },

    loadChartData() {
      //loading last 12 Mounths data
      const daysAgo = moment().subtract(365, 'days').valueOf()
      this.bills.view.paidBillsProducts.map(paidItem => {
        if (moment(paidItem.BillsProduct.date).valueOf() >= daysAgo) {
          var month = moment(paidItem.BillsProduct.date).get('month')

          if (this.salesChart.chartData.datasets[0].data[month] != undefined) {
            this.salesChart.chartData.datasets[0].data[month] += paidItem.BillsProduct.amount * paidItem.BillsProduct.price
          }
          else { this.salesChart.chartData.datasets[0].data[month] = 0 }
        }
      })
    },

    changeBlockEdit() {
      var blockEdit = this.agentData.place_id == 0
      this.$emit('emitBlockEdit', blockEdit)
    },

    setAgentLastFormation(courseSlug) {
      let lastPendingCourse = { date: '2000-01-01 00:00:00' }
      this.agentFormationCourses[courseSlug]['courses'].map(course => {
        if (course.date > lastPendingCourse.date && course.date.substring(0, 4) <= (new Date()).getFullYear() && !this.agentData.formations[course.id]) {
          lastPendingCourse = course
        }
      })

      if (document.getElementById('chbx_' + courseSlug + '_' + lastPendingCourse.date.substring(0, 4))) {
        document.getElementById('chbx_' + courseSlug + '_' + lastPendingCourse.date.substring(0, 4)).click()
      } else {
        alert('nenhum curso cadastrado. acesse nosso suportre!')
      }
    },

    removeAgentFormation(slug, year, id) {
      document.getElementById('chbx_' + slug + '_' + year).click()
    },

    setAgentFormation(formation, courseSlug) {
      let formationFileXfield = 'formationfile_' + formation.id + '_' + formation.date.substring(0, 4)
      let formationValidXfield = 'formationvalid_' + formation.id + '_' + formation.date.substring(0, 4)
      if (this.agentData.formations[formation.id]) {
        this.agentData.formations[formation.id] = undefined
        this.currentCoursersItems = this.currentCoursersItems.filter(course => course.id != formation.id)
        delete this.mainPlaceAgentData[formationFileXfield]
        delete this.mainPlaceAgentData[formationValidXfield]
      }
      else {
        this.agentData.formations[formation.id] = new Number(formation.id)
        this.mainPlaceAgentData[formationFileXfield] = {
          label: formationFileXfield,
          public_label: "Certificado: " + formation.name + '(' + formation.date.substring(0, 4) + ')',
          type: "hidden",
          value: ""
        }

        this.mainPlaceAgentData[formationValidXfield] = {
          label: formationValidXfield,
          public_label: "Validade: " + formation.name + '(' + formation.date.substring(0, 4) + ')',
          type: "hidden",
          value: (new Date()).toISOString().substring(0, 4)
        }
        this.currentCoursersItems.push({
          id: formation.id,
          date: formation.date,
          name: formation.name,
          slug: courseSlug
        })
      }
    },

    toggleAgentFormation(e, formation, courseSlug) {
      document.getElementById('chbx_' + courseSlug + '_' + formation.date.substring(0, 4)).click()
      setTimeout(() => { document.getElementById('chbx_' + courseSlug + '_' + e.target.value).click() }, 0);
    },

    setCourseLimit(e, formation, courseSlug) {
      let formationValidXfield = 'formationvalid_' + formation.id + '_' + formation.date.substring(0, 4)
      if (this.mainPlaceAgentData[formationValidXfield] == undefined) {
        this.mainPlaceAgentData[formationValidXfield] = {
          label: formationValidXfield,
          public_label: "Validade: " + formation.name + '(' + formation.date.substring(0, 4) + ')',
          type: "hidden",
          value: e.target.value
        }
      }
      else {
        this.mainPlaceAgentData[formationValidXfield]['value'] = e.target.value
      }
    },

    setActiveCheckboxMultiple(event, poi, checkboxmultipleLabel) {
      poi.id = `_${poi.value}`
      //final result
      let result = []
      //find current field in formFields
      let formField = this.formFields.find((field, idx) => { return field.label == checkboxmultipleLabel })

      if (!formField.value) { formField.value = [] }
      let formFieldValueIds = formField.value.map((op) => { return op.id })

      //find in current values
      let valueIndex = formFieldValueIds.indexOf(poi.id)
      if (valueIndex >= 0) {
        formFieldValueIds.splice(valueIndex, 1)
      }
      else { formFieldValueIds.push(poi.id) }

      result = formField.options.filter((option) => { return formFieldValueIds.indexOf(`_${option.value}`) >= 0 })

      result = result.map((res) => {
        res.id = `_${res.value}`
        return res
      })
      formField.value = result
    },

    getMask(field) {
      var cod_country = ''

      if (this.phoneFlag != undefined && this.phoneFlag != null && this.phoneFlag != '') {
        cod_country = this.dialCodesArray.find(i => i.iso == this.phoneFlag).dialcode
        cod_country = "+" + cod_country
      }

      switch (field.label) {
        case 'address_cep':
          return ['#####-###']
          break

        case 'mobile':
          return [`${cod_country} (##) #####-####`]
          break

        case 'phone':
          return [`${cod_country} (##) #####-####`]
          break

        default:
          break
      }
      return false
    },

    getDocMask(value) {
      const doc = String(value || '')
      if (/[A-Za-z]/.test(doc)) return 'AA######'
      const digits = doc.replace(/\D/g, '')
      if (digits.length > 11) return '##.###.###/####-##'
      return '###.###.###-##'
    },

    validateField() {
      this.fieldErrors = {}
      const targets = document.querySelectorAll('[bc_label]')
      targets.forEach(target => {
        const fieldName = target.name || target.getAttribute('bc_label');
        let isValid = true;
        let errorMessage = target.getAttribute('aria-invalid') || 'Valor inválido para o campo ' + fieldName;

        if (!target.value && target.required) { isValid = false; }

        if (target.getAttribute('bc_label') === 'mailaddress') {
          isValid = this.validEmail(target.value);
          errorMessage = 'E-mail inválido!';
        }

        this.$set(this.fieldErrors, fieldName, !isValid ? errorMessage : '');
        this.$emit('emitFormErrors', !isValid);

        if (!isValid) { this.$notify({ message: errorMessage, duration: 5000, type: 'error', overlap: false }); }
        else { this.$emit('emitFormWaiting', false); }
      })
    },

    async getAgentImage(path) {
      if (path && this.agent.id) {
        bocapioService.getFileByPath(path)
          .then(rsp => {
            var blob = new Blob([rsp.data], { type: rsp.data.type });
            var agentTmpImage = URL.createObjectURL(blob)
            this.$emit("emitAgentTmpImage", agentTmpImage)
          })
          .catch(() => {
            var agentTmpImage = cakeBaseURL + 'images/display/' + path
            this.$emit("emitAgentTmpImage", agentTmpImage)
          })
      }
    },

    onImageChange(e) {
      const file = e.target.files[0]
      var agentTmpImage = URL.createObjectURL(file)
      this.$emit("agentTmpImage", agentTmpImage)
    },

    onFileChange(e) {
      var agentTmpFiles = {}
      agentTmpFiles[e.target.name] = { slug: e.target.name, public_label: e.target.attributes.public_label.nodeValue, file: e.target.files[0] }
      this.$emit("emitAgentTmpFiles", agentTmpFiles)
    },

    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    downloadFile(path, public_label) {
      bocapioService.getFileByPath(path)
        .then(rsp => {
          var blob = new Blob([rsp.data], { type: rsp.data.type });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = (this.agentData.name ? this.agentData.name + ' - ' : '') + public_label;
          link.click();
        })
        .catch(error => {
          alert("Arquivo não encontrado \n" + error);
        });

    },

    isCourseAvailable(courseSlug, courseYear) {
      if (document.getElementById('chbx_' + courseSlug + '_' + courseYear)) {
        return document.getElementById('chbx_' + courseSlug + '_' + courseYear).checked
      }
      return true;
    },

    triggerFileInput() { this.$refs.fileInput.click(); },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let agentTmpImage = e.target.result;
          this.$emit("emitAgentTmpImage", agentTmpImage)
          this.$emit("emitAgentUploadImage", file)
        };
        reader.readAsDataURL(file);
      }
    },
  },

  async created() {
    this.handle_my_place_agents = hasModule('handle_my_place_agents')
    this.handle_city_agents = hasModule('handle_city_agents')

    var agentTmpImage = 'img/theme/backpacker.png'
    this.$emit("emitAgentTmpImage", agentTmpImage)

    this.agentData = this.agent
    let year = 2010

    for (; year <= (new Date()).getFullYear() + 10; year++) {
      if (year <= (new Date()).getFullYear()) {
        this.courseYears[year] = year
      }
      this.courseLimitYears[year] = year
    }

    let categoryEntry = Object.entries(this.agentCategories).find((cat) => { return cat[1] == this.agent.category })
    this.agent.category = categoryEntry ? categoryEntry[0] : 1

    this.setBlockEdit()
    this.agentData.removeimage = 0
    this.getAgentImage(this.agentData.images)
    this.salesChart.chartData.labels = this.last12Mounths().reverse()
    this.formFields = Object.values(this.mainPlaceAgentData)

    if (this.mainPlaceAgentData.active.value === 'true') {
      this.mainPlaceAgentData.active.value = true
    }
    else {
      this.mainPlaceAgentData.active.value = false
    }
  },

  async mounted() {
    this.loadAgentAssociatePlaces()
    this.loadAgentFormationCourses()
    setTimeout(() => {
      let requireds = document.querySelectorAll("[required]")
      if (requireds) {
        // requireds[0].focus()
      }
    }, 0)

    if (this.agent.isNew && this.agent.isNew == true) { this.mainPlaceAgentData.active.value = true }

    if (!this.handle_my_place_agents) { this.pages.zLast = this.pages.zLast.filter(item => item != 'formation_data_session') }
    if (!this.handle_city_agents) { this.pages.zLast = this.pages.zLast.filter(item => item != 'afilitaion_data_session') }
    if (this.pages.zLast.length === 0) { delete this.pages.zLast }

  },
};
</script>

<style lang="css">
/*
[class*="session"], [class*="pagecontrol_"] {
  border-width: 1px;
  border-style: solid;
  border-color: red !important;
  padding: 10px;
  margin: 0 0 10px 0;
} */


/* .modal-add-footer {
display: flex;
   }

   .progress-bar {
    background-color: #D9D9D9;
    width: auto;
    height: 10px;
    border-radius: 10px;
    margin-bottom: 15px;
   }

   .progress-bar-inside {
    background-color: #A7AA37;
    width: auto;
    height: 10px;
    border-radius: 10px;
   } */
.removebuttonmask {
  width: 300px;
  height: 100px;
  max-height: 20px;
  position: relative;
}

.contentbuttonmask {
  position: absolute;
  bottom: 0;
  width: fit-content;
  text-align: center;
  line-height: 20px;
}

.custom-dropdown .btn-secondary {
  background-color: white;
  box-shadow: none;
  padding: 10px;
  border: none;
}

.custom-dropdown .btn-secondary:active {
  background-color: white;
  box-shadow: none;
}

.custom-dropdown .dropdown-menu {
  background-color: #ffffff;
  min-width: 25vw;
}

.custom-dropdown .dropdown-item {
  padding: 10px;
  color: #191919;
}

.custom-dropdown .dropdown-item:hover {
  background-color: #ddd;
}

.image-upload-wrapper {
  position: relative;
  display: inline-block;
  width: 160px;
  height: 160px;
  border: 1px dashed gray;
  overflow: hidden;
  cursor: pointer;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hidden-input {
  display: none;
}

.img-agent-info {
  display: flex;
}


.top-2-input {
  margin-left: 30px;
}

@media screen and (max-width: 900px) {
  .img-agent-info {
    display: block;
  }

  .top-2-input {
    margin-left: 0;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
